<!--
 * @Description: osis证书组件
 * @Author: gaohc
 * @Date: 2022-12-09 15:45:35
 * @LastEditTime: 2022-12-28 10:22:05
-->

<template>
  <div class="osis-cert-wrap">
    <div class="cert-content">
      <span v-html="certHtml"></span>
    </div>
    <div class="issue-unit">
      <span>{{certData.sign}}</span>
      <img src="../../../../assets/reviewmng/icon-certificate-badge.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    certData: {type: Object, default: {}}
  },

  data() {
    return{
      certHtml: this.certData.content
    }
  }
};
</script>

<style scoped>
.osis-cert-wrap {
  width: 250px;
  height: 182px;
  background-image: url(../../../../assets/reviewmng/icon-certificate-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  font-size: 12px;
}

.cert-content{
  margin-top: 38px;
  padding: 0 20px;
  min-height: 85px;
  text-indent: 30px;
  line-height: 18px;
  color: #333;
}

.issue-unit{
  margin-top: 5px;
  padding: 0 20px 0 75px;
  text-align: right;
  position: relative;
  color: #333;
}

.issue-unit img{
  width: 60px;
  height: 60px;
  position: absolute;
  top: -22px;
  right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/attendantReviewDetails/OsisCertificate.vue